export enum ELoginResponseStatus {
  NO_ERROR = 0,
  INVALID_EMAIL_OR_PASSWORD = 400,
  INCORRECT_PASSWORD = 401,
  INVALID_CUSTOMER = 403,
  UNKNOWN_CUSTOMER = 404,
  PASSWORD_NOT_SET = 409,
  SERVER_ERROR = 500,
}
